<div class="card panel-flat-color primary-panel" style="margin-bottom: 0">
    <div class="panel-flat-header">
        <h3>Service Provider Fees</h3>
    </div>
    <div class="panel-flat-body position-relative" [formGroup]="form()">
        <div class="referral-field-grid">
            <label class="referral-field-label" for="rlsFeeTypeId">Fee Type</label>
            <referral-input-with-revert
                formControlName="rlsFeeTypeId"
                [systemValue]="systemReferral()?.rlsFeeTypeId"
                [originalValue]="originalReferral()?.rlsFeeTypeId"
                [selectOptions]="rlsFeeTypeOptions"
                [isNumber]="true"
            />

            <label class="referral-field-label" for="rlsFeeRate">
                Previous Fee Rate
                @if (isRLSFeeOptional) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="rlsFeeRate"
                [systemValue]="systemReferral()?.rlsFeeRate"
                [originalValue]="originalReferral()?.rlsFeeRate"
                [isPercent]="true"
            />
            <label class="referral-field-label" [style.margin-bottom.px]="editMode() ? 47 : 0" for="feeTermsLanguage">
                Notes
                @if (editMode()) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="feeTermsLanguage"
                [systemValue]="systemReferral()?.feeTermsLanguage"
                [originalValue]="originalReferral()?.feeTermsLanguage"
                [isTextArea]="true"
                [maxlength]="8000"
            />
            <label class="referral-field-label" for="attyFeesPaidByClient">
                Att Fees prev paid by client
                @if (editMode()) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="attyFeesPaidByClient"
                [systemValue]="systemReferral()?.attyFeesPaidByClient"
                [originalValue]="originalReferral()?.attyFeesPaidByClient"
                [isBoolean]="true"
                [hasUnknown]="true"
            />

            <label class="referral-field-label" for="rlsExpertPayorId">Expert Payor</label>
            <referral-input-with-revert
                formControlName="rlsExpertPayorId"
                [systemValue]="systemReferral()?.rlsExpertPayorId"
                [originalValue]="originalReferral()?.rlsExpertPayorId"
                [selectOptions]="rlsPayorTypeOptions"
                [isNumber]="true"
            />

            <label class="referral-field-label" for="rlsFilingFeePayorId">Filing Fee Payor</label>
            <referral-input-with-revert
                formControlName="rlsFilingFeePayorId"
                [systemValue]="systemReferral()?.rlsFilingFeePayorId"
                [originalValue]="originalReferral()?.rlsFilingFeePayorId"
                [selectOptions]="rlsPayorTypeOptions"
                [isNumber]="true"
            />

            <label class="referral-field-label" for="potentialTaxSavings">
                Potential Tax Savings
                @if (editMode()) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="potentialTaxSavings"
                [systemValue]="systemReferral()?.potentialTaxSavings"
                [originalValue]="originalReferral()?.potentialTaxSavings"
                [isNumber]="true"
                [maxlength]="18"
                [precision]="2"
                [isCurrency]="true"
            />
            <label class="referral-field-label" for="potentialRLSFees">
                Potential Fees
                @if (editMode()) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="potentialRLSFees"
                [systemValue]="systemReferral()?.potentialRLSFees"
                [originalValue]="originalReferral()?.potentialRLSFees"
                [isNumber]="true"
                [maxlength]="18"
                [precision]="2"
                [isCurrency]="true"
            />
            <label class="referral-field-label" for="fixedFeeAmount">
                Fixed Fees
                @if (isFixedFeesOptional) {
                    <span class="optional-marker">(Optional)</span>
                }
            </label>
            <referral-input-with-revert
                formControlName="fixedFeeAmount"
                [systemValue]="systemReferral()?.fixedFeeAmount"
                [originalValue]="originalReferral()?.fixedFeeAmount"
                [isNumber]="true"
                [maxlength]="18"
                [precision]="2"
                [isCurrency]="true"
            />
        </div>
    </div>
</div>
